export default function clearMessage(state, action) {
  const { key, message } = action

  // only clear generalError messages if the message text matches
  if (key === 'generalError' && state.messages[key] !== message) {
    return state
  }

  return Object.assign({}, state, {
    messages: {
      ...state.messages,
      [key]: null
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/clearMessage.js